<template>
    <div class="feature-icon-list">
        <div class="row">
            <div class="col-lg-6">
                <div class="feature-icon-list__media wow move-up">
                    <img src="../assets/img_design/img/pc/service_img.jpg" class="img-fluid rounded" alt="">
                </div>
            </div>
            <div class="col-lg-4">
                <!-- <div class="feature-icon-list__content">
                    <div class="feature-icon-list-wrapper">
                        <div v-for="feature in features" :key="feature.id" class="single-feature-icon wow move-up">
                            <div class="single-feature-icon__media">
                                <img :src="feature.icon" class="img-fluid" alt="">
                            </div>
                            <div class="single-feature-icon__content">
                                <h6 class="title">{{ feature.title }}</h6>
                                <div class="text">{{ feature.desc }}</div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <h5 class="margin-bottom-20">{{lan.key12[cur_lan]}}</h5>
                <hr>
                <ul class="ul-style margin-bottom-20">
                    <li class="margin-bottom-20">{{lan.key13[cur_lan]}}</li>
                    <li class="margin-bottom-20">{{lan.key14[cur_lan]}}</li>
                    <!-- <li class="margin-bottom-20">{{lan.key15[cur_lan]}}</li> -->
                    <li class="margin-bottom-20">{{lan.key16[cur_lan]}}</li>
                    <li class="margin-bottom-20">{{lan.key17[cur_lan]}}</li>
                </ul>
                <!-- <p>{{lan.key18[cur_lan]}}</p> -->

                <div class="video-button-container video-popup">
                   
                        <div class="video-play" @click="showvideo=1">
                            <i class="fa fa-play-circle"></i>
                            <span class="video-text">{{lan.key19[cur_lan]}}</span>
                        </div>
                        <div class="pop-video" v-if="showvideo"> <div class='pop-content'>
                            <div class="close-pop" @click="showvideo=0">X</div>
                            <video width="100%" height="600" poster="https://cdn2.cbredata.com/creis/videos/CREIS_SERVICE_CoverPage.png" controls>
            <source :src="'https://cdn2.cbredata.com/creis/videos/CREIS_SERVICE_'+(cur_lan=='jp'?'JP':'EN')+'.mp4'" type="video/mp4">
          
        </video></div></div>
                    
                </div>
            </div>
            <div class="col-lg-2">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'featureList',
         data (){
            return {
                showvideo:0,
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
            }
        },
        // data (){
        //     return {
        //         features: [
        //             {
        //                 icon: require('../assets/img/icons/aeroland-branding-box-image-01-1.png'), 
        //                 title: 'オフィス全国13都市', 
        //                 desc: '原則として延床面積1000坪以上、かつ新耐震基準に 対象ビル 準拠した賃貸オフィスビル'
        //             },
        //             {
        //                 icon: require('../assets/img/icons/aeroland-branding-box-image-02-1.png'), 
        //                 title: 'インダストリアル全国16都市', 
        //                 desc: '対象都市に所在する、主な用途が倉庫であ る一般募集された施設'
        //             },
        //             {
        //                 icon: require('../assets/img/icons/aeroland-branding-box-image-03-1.png'), 
        //                 title: 'リテール全国5都市', 
        //                 desc: ' CBREが独自に設定した対象地、ワンフロアの面積が200m²程度の建物を想定'
        //             },
        //         ]
        //     }
        // }
    }
</script>
<style>
.video-play{cursor: pointer;}
.pop-video{position: fixed;top: 0;left: 0;background: rgba(0,0,0,0.9);z-index: 9998;width: 100%;height: 100%;}
.pop-content{margin: 50px auto; width: 78%;max-width: 1050px; height: 660px;padding: 1%;z-index: 9999;box-shadow: #666 0px 0px 8px; background: #fff;border-radius: 8px;}
.close-pop{float: right;margin-right: -5px;margin-top: -5px; width: 25px;height: 25px;border: 1px solid #000;color: #000;border-radius: 20px;text-align: center;line-height: 25px;}
</style>
